import wheel from '@services/wheel'
import {subscribe} from '@services/events'
import ResizeObserver from 'resize-observer-polyfill'

export default function scrollbar({
  smooth = 5,
  completeThreshhold = .01,
  speed,
  inertiaScrolling = true,
  autohide = true
} = {}){

  const trackElement = Object.assign(document.createElement('div'),{className:`${autohide?'scrollbar--autohide':''} scrollbar__track`});
  const handleElement = Object.assign(document.createElement('div'),{className:'scrollbar__handle'});
  trackElement.appendChild(handleElement);
  document.body.appendChild(trackElement);

  let scale = 1;
  let position = 0;

  const getMaxScrollTrack = ()=>(1 - scale) * trackElement.getBoundingClientRect().height;

  const getMaxScroll = ()=>document.scrollingElement.scrollHeight - window.innerHeight;

  const updateFactors = ()=>{
    const {scrollTop,scrollHeight} = document.scrollingElement;

    scale = Math.min(1,window.innerHeight / scrollHeight);
    position = scrollTop / getMaxScroll();
  }

  const updateElements = ()=>{
    handleElement.style.setProperty('height',`${scale*100}%`);
    handleElement.style.setProperty('transform',`translateY(${getMaxScrollTrack()*position}px)`);
  }

  const onUpdate = ()=>{
    updateFactors();
    updateElements();
  }

  const wheelDestructor = wheel({smooth,completeThreshhold,speed,inertiaScrolling,onUpdate});

  let down = false;
  let offsetY = 0;
  const handleListener = subscribe(handleElement,'mousedown',e=>{
    e.preventDefault();

    if(e.type === 'mousedown' && e.which === 1){
      down = true;
      offsetY = e.offsetY;
    }else if( down && e.type === '' && e.which === 1){
      down = false;
    }
  });
  const windowListener = subscribe(window,'mousemove mouseup',e=>{
    if(down){
      if(e.type === 'mouseup' && e.which === 1){
        down = false;
      }else{
        position = Math.min(1,Math.max(0,(e.clientY - offsetY) / getMaxScrollTrack()));
        updateElements();
        document.scrollingElement.scrollTop = position * getMaxScroll();
      }
    }
  });

  const resizeObserver = new ResizeObserver(onUpdate);

  resizeObserver.observe(document.scrollingElement);

  onUpdate();

  return ()=>{
    wheelDestructor();
    handleListener();
    windowListener();
    resizeObserver.unobserve(document.scrollingElement);
    trackElement.parentElement.removeChild(trackElement);
  }
}